module.exports = __webpack_public_path__ + "img/NoSearchResult.b9264028.png";